import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const NavbarButton = styled(Button)(({ theme }) => ({
  padding: '6px 10px',
  minWidth: '50px',
  whiteSpace: 'nowrap',

  [theme.breakpoints.up('md')]: {
    marginLeft: '6px',
    marginRight: '6px',
  },

  '& .MuiButton-startIcon': {
    marginRight: '4px',
  },
}));

export default NavbarButton;
